import Axios from 'axios'

const getToken = () => {
  return window.localStorage.getItem('comunidadeIuppToken')
}

const axios = baseURL => {
  return Axios.create({
    headers: {
      'X-API-KEY': process.env.REACT_APP_COMUNIDADE_IUPP_KEY,
      Authorization: `bearer ${getToken()}`
    },
    baseURL: baseURL
  })
}

export default axios



// WEBPACK FOOTER //
// ./src/features/Services/ComunidadeIupp/axios.js